import { MutationCache, QueryClient, notifyManager } from '@tanstack/react-query'
import { apiErrorMessage } from '@/lib/apiError'
import { addToast } from '@/components/ui/Toast'

// 預設用 setTimeout 通知 React，isPending 要等下一輪才反映到畫面，快速雙擊的第二下會趕在按鈕 disabled 前送出。
// 改成 microtask：同一次點擊處理完、下一個點擊事件進來前，畫面就已更新
notifyManager.setScheduler((cb) => queueMicrotask(cb))

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 同舊版：每次進頁都重抓、失敗不重試、切回分頁或網路恢復都不自動重抓。
      // 要整個 session 共用一份的（選項類）在各自的 queryOptions 設 staleTime: Infinity
      staleTime: 0,
      gcTime: 5 * 60_000,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // 同舊版：離線時直接失敗。預設 'online' 會暫停請求，畫面卡在轉圈、恢復連線後才補送
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
  // 寫入類失敗預設跳錯誤 toast；要自己處理的 mutation 設 meta: { silentError: true }
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      // 401 已在 request 登出重載，不再跳錯誤 toast
      if (mutation.meta?.silentError || err?.status === 401) return
      addToast({ level: 'error', message: apiErrorMessage(err) })
    },
  }),
})
